var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccesibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 99,
    viewBox: "0 0 104 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_231_14410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7235 47.3335H21.7544C20.9569 47.3335 20.2276 46.8884 19.8624 46.1804C19.4972 45.4724 19.5579 44.6195 20.0189 43.9701L28.2002 32.4691C28.6654 31.8164 28.7304 30.9912 28.3748 30.2619C28.2151 29.9329 27.7264 29.1642 26.6585 29.1152L26.536 29.1131C25.0742 29.1131 23.8849 30.3024 23.8849 31.7642C23.8849 32.9397 22.9309 33.8936 21.7555 33.8936C20.58 33.8936 19.626 32.9397 19.626 31.7642C19.626 27.9536 22.7254 24.8542 26.536 24.8542C26.6404 24.8542 26.7426 24.8564 26.8458 24.8606C29.1744 24.966 31.175 26.2873 32.2035 28.3955C33.2373 30.5164 33.0339 33.0227 31.6711 34.9381L25.8823 43.0757H30.7235C31.899 43.0757 32.8529 44.0297 32.8529 45.2051C32.8529 46.3806 31.9 47.3335 30.7235 47.3335Z",
    fill: "url(#paint0_linear_231_14410)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9344 47.3338C45.759 47.3338 44.805 46.3798 44.805 45.2044V43.9469H36.2916C35.493 43.9469 34.7616 43.5008 34.3974 42.7907C34.0333 42.0805 34.0961 41.2255 34.5614 40.5761L45.2043 25.7415C45.7419 24.9898 46.7034 24.6714 47.586 24.9557C48.4665 25.2389 49.0638 26.0577 49.0638 26.9829V39.6881H50.3415C51.5169 39.6881 52.4709 40.6421 52.4709 41.8175C52.4709 42.993 51.5169 43.9469 50.3415 43.9469H49.0638V45.2044C49.0638 46.3798 48.1109 47.3338 46.9344 47.3338ZM40.4407 39.6881H44.8061V33.6043L40.4407 39.6881Z",
    fill: "url(#paint1_linear_231_14410)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.622 66.3988C66.2557 66.3988 65.8852 66.304 65.5466 66.107C64.532 65.5108 64.1923 64.2065 64.7864 63.1929L73.5937 48.1773H66.6231C65.4476 48.1773 64.4937 47.2244 64.4937 46.0479C64.4937 44.8724 65.4476 43.9185 66.6231 43.9185H77.3117C78.0751 43.9185 78.7799 44.3273 79.159 44.9896C79.538 45.6518 79.5348 46.4674 79.1483 47.1254L68.4586 65.3458C68.0647 66.0218 67.3535 66.3988 66.622 66.3988Z",
    fill: "url(#paint2_linear_231_14410)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9606 66.3979C46.6061 66.3979 46.2462 66.3095 45.9151 66.1221C44.8919 65.544 44.5299 64.244 45.1091 63.2208L66.1723 25.9346C66.7504 24.9125 68.0504 24.5495 69.0736 25.1287C70.0979 25.7068 70.4588 27.0057 69.8807 28.03L48.8164 65.3151C48.4257 66.0093 47.7038 66.3979 46.9606 66.3979Z",
    fill: "url(#paint3_linear_231_14410)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 90.6265C24.1869 90.6265 4 70.4395 4 45.6265C4 20.8134 24.1869 0.626465 49 0.626465C73.8131 0.626465 94 20.8134 94 45.6265C94 46.8019 93.046 47.7559 91.8706 47.7559C90.6951 47.7559 89.7412 46.8019 89.7412 45.6265C89.7412 23.1611 71.4643 4.88531 49 4.88531C26.5357 4.88531 8.25884 23.1611 8.25884 45.6265C8.25884 68.0919 26.5357 86.3676 49 86.3676C63.4226 86.3676 76.9103 78.624 84.1983 66.1573C84.7924 65.1426 86.0945 64.8008 87.1113 65.3939C88.126 65.988 88.4678 67.2912 87.8747 68.3069C79.8266 82.0736 64.9313 90.6265 49 90.6265Z",
    fill: "url(#paint4_linear_231_14410)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8721 47.7559C91.3269 47.7559 90.7829 47.5483 90.3666 47.132L84.5426 41.308C83.7111 40.4765 83.7111 39.1285 84.5426 38.297C85.3741 37.4655 86.7221 37.4655 87.5536 38.297L91.8721 42.6144L96.1905 38.297C97.0221 37.4655 98.37 37.4655 99.2015 38.297C100.033 39.1285 100.033 40.4765 99.2015 41.308L93.3776 47.132C92.9623 47.5483 92.4172 47.7559 91.8721 47.7559Z",
    fill: "url(#paint5_linear_231_14410)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_231_14410",
    x: 0,
    y: 0.626465,
    width: 103.825,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_231_14410"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_231_14410",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_14410",
    x1: 26.1079,
    y1: 38.4026,
    x2: 26.5438,
    y2: 47.3187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2688"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_231_14410",
    x1: 43.1321,
    y1: 38.4022,
    x2: 43.4476,
    y2: 47.3292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2688"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_231_14410",
    x1: 71.8164,
    y1: 57.4675,
    x2: 72.2026,
    y2: 66.3886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2688"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_231_14410",
    x1: 57.2392,
    y1: 49.8923,
    x2: 58.0174,
    y2: 66.3732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2688"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_231_14410",
    x1: 48.0922,
    y1: 54.8701,
    x2: 49.1212,
    y2: 90.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2688"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_231_14410",
    x1: 91.7116,
    y1: 43.7502,
    x2: 91.7847,
    y2: 47.7575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2688"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccesibility);
export default __webpack_public_path__ + "static/media/Accesibility.f5cb7d4dc0cb51cc03170556ae38d089.svg";
export { ForwardRef as ReactComponent };